import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import ProductsPage from './ProductsPage.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.PRODUCTS,
  permissions: ['administrator', 'agent'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/products'),
      name: 'products_index',
      meta,
      component: ProductsPage,
    },
  ],
};
